import React from "react";

const FILTERS = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "disabled", label: "Disabled" },
];

const UsersFilterBar = ({ viewMode, setViewMode }) => {
  return (
    <div className="flex flex-wrap">
      {FILTERS.map((f) => (
        <button
          key={f.value}
          type="button"
          className={`ma1 bn br-pill ph3 pv2 pointer fw6 ${
            viewMode === f.value ? "bg-gold black" : "bg-light-gray dark-gray"
          }`}
          onClick={() => setViewMode(f.value)}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
};

export default UsersFilterBar;